export class dynamicFieldProperties {
  field_message_id: string;
  visible?: boolean;
  mandatory?: boolean;
  editable?: boolean;
  default_value?: any;
  description?: string;
  ui_field_name?: string;
  error_label?: string;
  required_roles?: string;
  max_length?: string;
  editable_in_steps?: number[] | any;

  constructor(item: any) {
    this.field_message_id = item.field_message_id;
    this.visible = item.visible;
    this.mandatory = item.mandatory;
    this.editable = item.editable;
    this.default_value = item.default_value;
    this.description = item?.description;
    this.ui_field_name = item.ui_field_name;
    this.error_label = item.error_label;
    this.required_roles = item.required_roles;
    this.max_length = item.max_length;
    if (Array.isArray(item.editable_in_steps)) {
      this.editable_in_steps = item.editable_in_steps;
    } else if (typeof item.editable_in_steps === "function") {
      this.editable_in_steps = item.editable_in_steps;
    } else {
      const steps = item?.editable_in_steps
        ?.split(";")
        ?.map((step: string) => {
          const parsed = parseInt(step, 10);
          return isNaN(parsed) ? -1 : parsed;
        })
        .filter((p: number) => p !== -1);
      this.editable_in_steps = steps ? steps : [];
    }
  }
}
